<template>
  <div class="footer">
    <h2>联系方式</h2>
    <p>企业邮箱：info@superfishai.com</p>
    <p>公司地址：北京市朝阳区东三环北路3号幸福大厦A座1213</p>
    <p>云南省昆明市官渡区吴井路新摩尔商务中心A座801室</p>
    <p>联系电话：0871-63175716   18910677918</p>
    <p>微信号：beifei-superfishai</p>
    <h3>© 2021 云南北飞科技有限公司版权所有</h3>
    <div>
      <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=53019102000194" target="_blank">公安备案号53019102000194</a></span>
      <span><a href="https://beian.miit.gov.cn" target="_blank">{{$route.fullPath.indexOf("superfishai")>-1?beian:beian1}}</a></span>
      <span>教APP备5300002号 ｜ 教APP备1100611号</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      beian: '滇ICP备18000852号',
      beian1: '滇ICP备18000852号'
    }
  }
}
</script>

<style scoped>
  .footer{
    height: 22vw;
    background: #343434;
    text-align: center;
    color: white;
    font-size: 0.8vw;
    line-height: 1vw;
  }
  .footer>h2{
    font-size: 1.8vw;
    padding: 2vw 0 1vw;
  }
  .footer>h3{
    font-size: 1.6vw;
    padding: 1.2vw 0 0.2vw;
  }
  .footer>p{
    margin-bottom: 1vw;
  }
  a{
    color: white;
    padding: 0 1vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue